import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AccessControlListMaintenanceDto } from './AccessControlListMaintenanceDto';
import { AccessControlItemMaintenanceDto } from './AccessControlItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { AlertService } from '../../../services/alert/alert.service';
import { LoadingService } from '../../../services/loading/loading.service';
import { Observable } from 'rxjs';


@Injectable()
export class AccessControlMaintenanceController extends
    BaseMaintenanceController<AccessControlListMaintenanceDto, AccessControlItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "accesscontrol");
    }


    public getResourceRoot(): string {
        return "ACCESSCONTROL";
    }

    public buildUrl(uri: string): string {
        return "/system/screensandforms/accesscontrolsetting" + uri;
    }

    public getAccessControlsUser(): Observable<Array<AccessControlListMaintenanceDto>> {
        return this.get(this.getBaseUrl() + "/accesscontrolsuser");
    }

}
